import { Hammer } from "lucide-react";
import StageShell from "@/components/StageShell";
import { useRun } from "@/hooks/useRun";
import { api } from "@/lib/api";

const COLS = [
  { id: "has_shows", label: "Has and shows", tone: "border-emerald-500/40 text-emerald-300" },
  { id: "has_hidden", label: "Has but hidden", tone: "border-amber-500/40 text-amber-300" },
  { id: "missing", label: "Missing (never added)", tone: "border-rose-500/40 text-rose-300" },
];

export default function Stage3({ job, refresh }) {
  const runHook = useRun(job.id, 3, () => refresh());
  const gap = job.gap;
  const relabel = async (kw, label) => { await api.patch(`/jobs/${job.id}/gap`, { keyword: kw, label }); refresh(); };
  return (
    <StageShell job={job} stage={3} refresh={refresh} runHook={runHook}
      runs={[{ action: "gap_check", label: gap ? "Re-run gap check" : "Run gap check", testid: "gap-check-button" }]}>
      {!gap ? <div className="card-surface text-sm text-muted-foreground">Run the gap check to compare the FactSheet and resume with the must-have keywords.</div> : (
        <>
          <div className="grid grid-cols-3 gap-4" data-testid="gap-check-board">
            {COLS.map((col) => {
              const items = gap.items.filter((i) => i.label === col.id);
              return (
                <div key={col.id} className="card-surface" data-testid={`gap-col-${col.id}`}>
                  <div className={`text-sm font-semibold mb-3 inline-block px-2 py-0.5 rounded border ${col.tone}`}>{col.label} · {items.length}</div>
                  <div className="space-y-1.5">
                    {items.map((i) => (
                      <div key={i.keyword} className="flex items-center gap-2 text-sm bg-slate-900 rounded-md px-2 py-1.5" data-testid={`gap-item-${i.keyword}`}>
                        <span className="flex-1">{i.keyword}{i.must_have && <span className="ml-1 text-[10px] text-blue-300">must</span>}</span>
                        {i.override && <span className="text-[10px] text-slate-500">staff</span>}
                        <select value={i.label} onChange={(e) => relabel(i.keyword, e.target.value)} className="bg-transparent text-[11px] border border-border rounded px-1">
                          {COLS.map((c) => <option key={c.id} value={c.id}>{c.label.split(" (")[0]}</option>)}
                        </select>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="card-surface" data-testid="skills-to-build">
            <div className="flex items-center gap-2 mb-3"><Hammer size={15} className="text-amber-400" /><div className="font-semibold">Skills to build</div><span className="text-xs text-muted-foreground">Missing items stay off the resume.</span></div>
            <div className="grid grid-cols-2 gap-3">
              {gap.skills_to_build.map((s) => (
                <div key={s.keyword} className="rounded-lg border border-border p-3 text-sm">
                  <div className="font-medium">{s.keyword} <span className="text-xs text-slate-500">· {s.kind} · {s.duration}</span></div>
                  <div className="text-slate-400 mt-1">{s.suggestion}</div>
                </div>
              ))}
              {!gap.skills_to_build.length && <div className="text-sm text-muted-foreground">Nothing missing.</div>}
            </div>
          </div>
        </>
      )}
    </StageShell>
  );
}
